// extracted by mini-css-extract-plugin
module.exports = {"App":"ourValues_App__ziO--","card":"ourValues_card__29ukQ","cardtop":"ourValues_cardtop__10chk"};